export const LETTERS_SENT_QUERY_KEY = 'letters-sent'
export const LETTERS_RECEIVED_QUERY_KEY = 'letters-received'
export const LETTERS_SUMMARY_QUERY_KEY = 'letters-summary'
export const LETTERS_ALLOWED_RECIPIENTS_QUERY_KEY = 'letters-allowed-recipients'
export const LETTER_DETAIL_QUERY_KEY = 'letter-detail'
export const LETTER_OVERVIEW_QUERY_KEY = 'letter-overview'
export const LETTER_RECIPIENTS_QUERY_KEY = 'letter-recipients'
export const LETTER_FORWARDS_QUERY_KEY = 'letter-forwards'
export const LETTER_REPLIES_QUERY_KEY = 'letter-replies'
